module.exports = __webpack_public_path__ + "img/unmute.3e1924e7.jpg";